const createHistory = require("history").createBrowserHistory
import { routerMiddleware, routerReducer } from "react-router-redux"
import { applyMiddleware, combineReducers, compose, createStore } from "redux"
import { createLogger } from "redux-logger"
import createSagaMiddleware from "redux-saga"
import { persistStore, persistReducer, PersistConfig } from "redux-persist"
import storage from "redux-persist/lib/storage"
import thunk from "redux-thunk"
import AppConfig from "../configs/AppConfig"
import immutablePersistenceTransform from "../helpers/ImmutablePersistenceTransform"
import reducers from "../redux/reducers"
import rootSaga from "../redux/sagas"

let store: any
let history: any

/* ------------- Redux Configuration ------------- */

const middleware: any[] = []
const enhancers: any[] = []

history = createHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)

if (AppConfig.isDevelopment) {
  const logger = createLogger({
    predicate: (getState, action) => action.type !== "COLLAPSE_OPEN_DRAWER"
  })
  middleware.push(logger)
}
middleware.push(thunk)
middleware.push(sagaMiddleware)
middleware.push(routeMiddleware)

/* ------------- Assemble Middleware ------------- */

enhancers.push(applyMiddleware(...middleware))

/* ------------- AutoRehydrate Enhancer ------------- */

// add the autoRehydrate enhancer
// if (ReduxPersist.active) {
//   enhancers.push(autoRehydrate());
// }

const persistConfig: PersistConfig = {
  key: "SagaAuth",
  storage,
  transforms: [immutablePersistenceTransform],
  whitelist: ["SagaAuth", "SagaCart", "SagaBooking"]
}

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    ...reducers,
    router: routerReducer
  })
)

store = createStore(persistedReducer, compose(...enhancers))
const persistor = persistStore(store)

// store = createStore(
//   combineReducers({
//     ...reducers,
//     router: routerReducer
//   }),
//   compose(...enhancers)
// );

//   if (ReduxPersist.active) {
//     RehydrationServices.updateReducers(store);
//   }

sagaMiddleware.run(rootSaga)

export { store, history, persistor }



// WEBPACK FOOTER //
// ./src/redux/store.ts